import { PipeTransform, Pipe } from '@angular/core';
import cronstrue from 'cronstrue';
@Pipe({
  name: 'cronHumanize',
})
export class CronHumanizePipe implements PipeTransform {
  constructor() {}

  transform(v: string): string {
    return cronstrue.toString(v);
  }
}
